import React, { useState } from "react";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  InputAdornment,
  CircularProgress,
} from "@mui/material";

interface Patient {
  mrn: string;
 ref_mrn?: string;
  patientName: string;
  guardiansName: string;
  gender: string;
  phonNumber: string;
  dob: string;
}

export default function PatientSearchDialog({
  loading,
  open,
  searchResults,
  onClose,
}: {
  loading: boolean;
  open: boolean;
  searchResults: Patient[];
  onClose: () => void;
}) {
  const [searchValue, setSearchValue] = useState("");

  const calculateAge = (dob: string) => {
    const birthDate = new Date(dob);
    const ageDiff = Date.now() - birthDate.getTime();
    const ageDate = new Date(ageDiff);
    const age = Math.abs(ageDate.getUTCFullYear() - 1970);
    if (age < 1) {
      const month = Math.abs(ageDate.getUTCMonth());
      return month < 1 ? "Newborn" : `${month} m `;
    }
    return `${age} y`;
  };
  const navigate = useNavigate();

  const handleSelect = (patient: Patient) => {
     navigate("/sample-collection", { state: { patient } });
    onClose();
  };

  // filter by guardian name
  const filteredResults = searchResults.filter((patient) =>
    patient.guardiansName.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      scroll="paper"
    >
      <DialogTitle sx={{ p: 1, fontSize: "14px" }}>
        
        <div className="flex items-center justify-between">
            Patient Search List
            <TextField
            className="custom-input"
          fullWidth
          size="small"
          placeholder="Search by Guardian Name"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
          sx={{ mb: 1, width: "300px" }}
        />
        </div>
      </DialogTitle>

      {/* 🔹 Search Bar */}

      {/* 🔹 Table */}
      <DialogContent sx={{ p: 1, maxHeight: "300px" }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ py: 0.5, px: 1, fontSize: "13px" }}>MRN</TableCell>
              <TableCell sx={{ py: 0.5, px: 1, fontSize: "13px" }}>Ref MRN</TableCell>
              <TableCell sx={{ py: 0.5, px: 1, fontSize: "13px" }}>Name</TableCell>
              <TableCell sx={{ py: 0.5, px: 1, fontSize: "13px" }}>Guardian Name</TableCell>
              <TableCell sx={{ py: 0.5, px: 1, fontSize: "13px" }}>Age</TableCell>
              <TableCell sx={{ py: 0.5, px: 1, fontSize: "13px" }}>Gender</TableCell>
              <TableCell sx={{ py: 0.5, px: 1, fontSize: "13px" }}>Phone</TableCell>
              <TableCell sx={{ py: 0.5, px: 1, fontSize: "13px" }} align="center">
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            { loading ? (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 1 }}>
                  <CircularProgress size={24} />
                </TableCell>
              </TableRow>
            ) : filteredResults.length > 0 ? (
              filteredResults.map((patient) => (
                <TableRow
                  key={patient.mrn}
                  sx={{ "& td": { py: 0.5, px: 1, fontSize: "12px" } }}
                >
                  <TableCell>{patient.mrn}</TableCell>
                  <TableCell>{patient.ref_mrn}</TableCell>
                  <TableCell>{patient.patientName}</TableCell>
                  <TableCell>{patient.guardiansName}</TableCell>
                  <TableCell>{calculateAge(patient.dob)}</TableCell>
                  <TableCell>{patient.gender}</TableCell>
                  <TableCell>{patient.phonNumber === "" ? "--" : patient.phonNumber}</TableCell>
                  <TableCell align="center">
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<WorkOutlineIcon />}
                      sx={{
                        fontSize: "11px",
                        textTransform: "none",
                        borderRadius: "8px",
                        px: 1.5,
                        py: 0.5,
                      }}
                      onClick={() => handleSelect(patient)}
                    >
                      Select
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 1 }}>
                  No records found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </DialogContent>

      <DialogActions sx={{ p: 1 }}>
        <Button size="small" onClick={onClose} sx={{ fontSize: "12px" }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
